import React, { useCallback, useEffect, useRef, useState } from 'react'
import { LocationOutlineIcon, SearchIcon } from 'asset/icons';
import Input from 'component/form/Input';
import { LuArrowUpRight } from 'react-icons/lu';
import { debounce } from 'lodash';
import axios from 'axios';
import { Bars } from 'react-loader-spinner';
import { useMutation } from 'react-query';
import { handleGetAddressDetails } from 'api/fetchers';

const ShipmentAddressInput = ({
    selectShippingMethod,
    updateShippingLeg,
    leg,
    shipmentType = "Departure Port",
    name = "departurePort",
}) => {
    const [selectPopUp, setSelectPopUp] = useState(false);
    const [loading, setLoading] = useState(false);
    const dropdownRef = useRef();
    const [allAddress, setAllAddress] = useState([]);

    const { mutateAsync: getAddressDetails, isLoading: isLoadingAddress } = useMutation({
        mutationFn: (data) => handleGetAddressDetails(data),
        mutationKey: ["get-address-details", leg?.id],
    });

    const getAddress = async (text) => {
        const data = { input: text };
        setLoading(true)
        await axios
            .post(`v1/utility/get-address-autocomplete`, data)
            .then((res) => {
                setAllAddress(res.data.data.predictions);
            })
            .catch((e) => {
            }).finally(() => {setLoading(false);});
    };
    
    const debouncedLog = useCallback(
        debounce((text) => {
            getAddress(text);
        }, 500),
        []
    );

    const handleChange = (name, text) => {
        updateShippingLeg(leg?.id, name, text);
        // Call the debounced function
        debouncedLog(text);
    };
    
    useEffect(() => {
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setSelectPopUp(false);
        }
    };

         document.addEventListener("mousedown", handleClickOutside);

         return () => {
             document.removeEventListener("mousedown", handleClickOutside);
         };
    }, [])

    
    return (
        <div className="relative">
            <div
                onClick={() => setSelectPopUp((prev) => !prev)}
                className="customInput flex items-center has-[:focus]:bg-[#EAECF0] bg-gray-30 rounded-md"
            >
                <div className="w-full ">
                    <div className="flex items-center">
                        <span className="mr-2 text-base balance_number text-gray-10">
                            <LocationOutlineIcon />
                        </span>

                        <div
                            className="w-full focus:bg-[#EAECF0] !shadow-none"
                        >
                            {leg?.[name]
                                ? leg?.[name]?.address
                                : name === "departurePort"
                                ? leg.type === "Truck"
                                    ? "Pick-up point"
                                    : shipmentType
                                : leg.type === "Truck"
                                ? "Drop-off point"
                                : "Destination Port"}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`bg-page-bg border rounded-xl pb-3 absolute cursor-auto px-3 !py-4 left-0 top-[110%] w-full shadow-[-16px_-16px_16px_-4px_#10182808,16px_16px_32px_-4px_#10182814] !transition-all !duration-[400ms] ${
                    selectPopUp
                        ? "translate-y-0 opacity-100 visible z-20"
                        : "translate-y-[30%] opacity-0 invisible -z-50"
                }`}
                onClick={(evt) => evt.stopPropagation()}
                ref={dropdownRef}
            >
                <Input
                    onChange={(text) => {
                        handleChange(name, text);
                    }}
                    placeholder="Search by address, city, or country"
                    unit={<SearchIcon className="-order-1 !ml-4 !size-6" />}
                    className="!shadow-[inset_0_0_0_1000px_#EAECF0] !pl-3 placeholder:text-base placeholder:font-normal"
                />

                <div className="pb-2 mt-3">
                    {loading ? (
                        <div className='flex items-center justify-center'>
                            <Bars height="22" width="22" color="#6f00ff" ariaLabel="bars-loading" />
                        </div>
                    ) : allAddress?.length ? (
                        allAddress?.map((addressDetails, index) => {
                            return (
                                <div
                                    key={index}
                                    className="flex items-center justify-between pb-2 transition-all border-b cursor-pointer hover:scale-[0.99]"
                                    onClick={isLoadingAddress ? () => { 
                                        return null
                                    } : async () => {
                                        const response = await getAddressDetails(addressDetails?.place_id);
                                           updateShippingLeg(leg?.id, name, {
                                               address:
                                                   addressDetails?.structured_formatting?.main_text,
                                               latitude:
                                                   response?.data?.result?.geometry?.location?.lat,
                                               longitude:
                                                   response?.data?.result?.geometry?.location?.lng,
                                               placeId: addressDetails?.place_id,
                                           });
                                           setSelectPopUp(false);
                                    }}
                                >
                                    <div className="space-y-1">
                                        <h1 className="text-base font-normal text-[#111827]">
                                            {addressDetails?.structured_formatting?.main_text},{" "}
                                            <span className="text-[#6C47FF]">
                                                {addressDetails?.terms?.[2]?.value}
                                            </span>
                                        </h1>
                                        <p className="text-sm text-[#6B7280]">
                                            {addressDetails?.structured_formatting?.secondary_text}
                                        </p>
                                    </div>
                                    <LuArrowUpRight className="w-5 h-5 text-[#111827]" />
                                </div>
                            );
                        })
                    ) : (
                        <p className="text-sm font-light text-center text-gray-500">
                            Enter search text...
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ShipmentAddressInput